module.exports = __webpack_public_path__ + "img/ceshi.69445797.jpg";